import Joi, { date } from '@hapi/joi'

export const taskTemplateSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Devision").messages({
        "any.invalid": `Devision Required`,
        "any.required": `Devision Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate Required`,
        "any.required": `Estate Required`
    }),
    estateTaskID: Joi.number().invalid(0).required().label("Task Name").messages({
        "string.empty": `Task Name required`,
        "string.pattern.base": `Please enter valid task name`,
    }),
    fieldID: Joi.number().label("Feild").messages({
        "any.invalid": `Feild Required`,
        "any.required": `Feild Required`
    }),
    sundryTask: Joi.number().invalid(0).required().label("Sundry Task").messages({
        "any.invalid": `Sundry Task Required`,
        "any.required": `Sundry Task Required`
    }),
    taskExpiration: Joi.string().allow(null).label("Task Duration"),
    numberOfWorkers: Joi.number().min(1).invalid(0).required().label("Number Of Employees").messages({
        "any.invalid": `Number Of Employees required`,
        "any.required": `Number Of Employees Required`,
        "string.min": `Number Of Employees should be greater than 0`,
    }),
    isActive: Joi.boolean().label("Active")
}
